import React, { useEffect, useState, useRef } from "react";
import Select from "react-select";
import { AlertModalInput } from "./AlertModalInput";
import { getMailAccountData, saveMailAccountData, uploadMailAccountCertificate } from "./mailRecipientService";
import { EMAIL_REGEX } from "../vars";
import { showDangerToast, showSuccessToast } from "../validation/ToastContainer";
import { Spinner } from "../view/Spinner";
import AlertAccountSecureField from "./AlertAccountSecureField";

const TLSVERSION = [
    { id: 0, name: 'TLS v1.1', value: 'TLSv1.1' },
    { id: 1, name: 'TLS v1.2', value: 'TLSv1.2' },
    { id: 2, name: 'TLS v1.3', value: 'TLSv1.3' },

]

const initMailAccount = {
    host: "",
    port: "",
    user: "",
    password: "",
    sender: "",
    secure: false,
    tlsVersion: ""
}

export function AlertAccountModal({ closeModal }) {
    const formId = "oct-alert-mail-account-form";

    const [loading, setLoading] = useState(true);
    const [mailAccount, setMailAccount] = useState(initMailAccount);
    const [passwordChanged, setPasswordChanged] = useState(false);

    const [tlsVersion, setTlsVersion] = useState(TLSVERSION[0]);

    const fileInputRef = useRef(null);

    useEffect(() => {
        async function load() {
            const account = await getMailAccountData();
            if (account && Object.keys(account).length) {
                setMailAccount(account);
                const savedTls = TLSVERSION.find(l => l.value === account.tlsVersion);
                if (savedTls) setTlsVersion(savedTls);
            }
            setLoading(false);
        }

        load();
    }, [])


    const onSubmit = async () => {
        if (isValid()) {
            const response = await saveMailAccountData(mailAccount, passwordChanged);
            if (response.ok) {
                showSuccessToast("Changes were saved", "Mail Account");
                closeModal();
            } else {
                showDangerToast("Something went wrong", "Mail Account");
            }
        }
    }

    const isValid = () => {
        return mailAccount.host &&
            mailAccount.port &&
            mailAccount.password &&
            EMAIL_REGEX.test(mailAccount.user);
    }


    const onChange = (key) => {
        return (value) => {
            if (key === 'password') {
                setPasswordChanged(true)
            }
            if (key === 'port') {
                if (isNaN(+value)) {
                    return;
                }
            }
            setMailAccount({ ...mailAccount, [key]: value });
        }
    }

    const onEnableSecureChange = (value) => {
        setMailAccount({ ...mailAccount, ...value });
    //     if (value && value.secure) {
    //         const onConfirm = () => {
    //             setMailAccount({ ...mailAccount, [key]: value });
    //             }

    //        setPopup(
    //            getConfirmPopup('Enabling Secure Setting is most recommended. Please upload a certificate as well!.',
    //                'Mail Account',
    //                () => onConfirm()
    //            )
    //        ); 
    //    } else {
    //     setMailAccount({ ...mailAccount, ...value });
    //    }
        
    }

    const onTlsVersionChange = (id) => {
        const selectedTLS = TLSVERSION.find(l => l.id === Number(id));
        setTlsVersion(selectedTLS);
        //setTlsVersion(TLSVERSION.find(l => l.id === Number(id)));
        setMailAccount({ ...mailAccount, tlsVersion: selectedTLS.value });
    }

    const uploadCertificate = (event) => {
        //setImage(event.target.files[0]);
        fileInputRef.current.click();
    }

    const onfileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            uploadMailAccountCertificate(file).then(async response => {
                if (response.ok) {
                    showSuccessToast(
                        "Certificate Uploaded",
                        "Mail Certificate"
                    );
                } else {
                    response = await response.json()
                    showDangerToast(response.message, "Error")
                }
                return !!response.ok
            });
        }
        event.target.value = null; // reset input so onChange fires again next time
    };

    const tlsVersionOptions = TLSVERSION.map(tls => ({ value: tls.id, label: tls.name }));

    return (
        <div className="modal oct_display-block modal-v2-root oct_alert-v2-modal oct_alert-v2-modal--mail">
            <div className="modal fade oct_modal show modal-v2-overlay">
                <div className="modal-dialog modal-dialog-centered modal-v2-dialog oct_alert-v2-modal-dialog" aria-modal="true">
                    <div className="modal-content modal-v2-shell oct_alert-v2-modal-shell">
                        <div className="modal-v2-header oct_alert-v2-modal-header">
                            <div className="modal-v2-header-top">
                                <div className="modal-v2-header-copy">
                                    <h2 className="modal-v2-heading">Mail Account</h2>
                                    <p className="modal-v2-subheading">
                                        Configure the SMTP account used for alert notifications and OTP delivery.
                                    </p>
                                </div>
                                <button type="button" className="close modal-v2-close" aria-label="Close" onClick={closeModal}>
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                        </div>

                        <div className="modal-body modal-v2-body oct_alert-v2-modal-body">
                            {loading ? (
                                <div className="oct_alert-v2-modal-loading">
                                    <Spinner />
                                </div>
                            ) : (
                                <form id={formId} className="oct_alert-v2-form modal-v2-form" autoComplete="off" onSubmit={(event) => {
                                    event.preventDefault();
                                    onSubmit();
                                }}>
                                    <div className="oct_alert-v2-form-grid oct_alert-v2-form-grid--single">
                                        <AlertModalInput
                                            label={"Host"}
                                            onChange={onChange("host")}
                                            placeholder={"smtp.host.com"}
                                            value={mailAccount.host}
                                            valid={mailAccount.host}
                                            required
                                        />
                                        <AlertModalInput
                                            label={"Port"}
                                            placeholder={"587"}
                                            value={mailAccount.port}
                                            onChange={onChange("port")}
                                            valid={mailAccount.port}
                                            required
                                        />
                                        <AlertModalInput
                                            label={"User"}
                                            placeholder={"no-reply@octopus.var"}
                                            value={mailAccount.user}
                                            onChange={onChange("user")}
                                            valid={EMAIL_REGEX.test(mailAccount.user)}
                                            required
                                        />
                                        <AlertModalInput
                                            label={"Password"}
                                            type={"password"}
                                            placeholder={"password"}
                                            value={mailAccount.password}
                                            onFocus={() => onChange("password")("")}
                                            onChange={onChange("password")}
                                            valid={mailAccount.password}
                                            required
                                        />
                                        <AlertModalInput
                                            label={"Sender"}
                                            placeholder={"sender"}
                                            value={mailAccount.sender}                                            
                                            onChange={onChange("sender")}
                                            valid={mailAccount.sender}
                                            required
                                        />
                                        <div className="form-group">
                                            <div className="oct_check oct_check-v2 oct_check-v2-remediation modal-v2-remediation-toggle">
                                                <div className="col-6">
                                                    <AlertAccountSecureField  value={mailAccount.secure}
                                                    onChange={(value) => onEnableSecureChange({ secure: value })}                                        
                                                    />
                                                </div>
                                                {mailAccount.secure &&
                                                    <div className="col-6">
                                                        {/* <button onClick={() => uploadCertificate(true)} className="oct_settings-btn-v2">Upload Certificate</button> */}
                                                        <button 
                                                            type="button"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                e.stopPropagation();
                                                                uploadCertificate();
                                                            }} 
                                                            className="oct_settings-btn-v2"
                                                        >
                                                            Upload Certificate
                                                        </button>
                                                        <input
                                                            id="file-upload"
                                                            type="file"
                                                            ref={fileInputRef}
                                                            onChange={onfileChange}
                                                            accept=".pem, .crt, .pfx, .p12"
                                                            className="d-none"
                                                        />
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                        
                                        {mailAccount.secure &&
                                            <div className="col">
                                                <label className="oct_filter-label">FROM</label>
                                                <Select
                                                    className="oct_selectsearch-v2"
                                                    classNamePrefix="oct-selectsearchsub-v2"
                                                    value={tlsVersionOptions.find(opt => opt.value === tlsVersion.id) || tlsVersionOptions[0]}
                                                    onChange={(option) => onTlsVersionChange(option.value)}
                                                    options={tlsVersionOptions}
                                                    isSearchable={false}
                                                />
                                            </div>
                                        }
                                        

                                    </div>
                                </form>
                            )}
                        </div>

                        <div className="modal-footer modal-v2-footer oct_alert-v2-modal-footer">
                            <div className="modal-v2-footer-note">
                                <span className="modal-v2-footer-note-star">*</span> Required fields
                            </div>
                            <div className="modal-v2-footer-actions oct_alert-v2-modal-actions">
                                <button type="button" className="btn modal-v2-btn modal-v2-btn-outline oct_alert-v2-modal-btn" onClick={closeModal}>
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    form={formId}
                                    className="btn modal-v2-btn modal-v2-btn-primary oct_alert-v2-modal-btn"
                                    disabled={loading || !isValid()}
                                >
                                    Save
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )

}
